if($('[data-scroll]').length){
	let _EffectH = 100;
	$(window).on('scroll load', function() {
		let _scTop = $(this).scrollTop();
		let _scBottom = _scTop + $(this).height();
		let _effectPos = _scBottom - _EffectH;
		$('[data-scroll]').each( function() {
			let _thisPos = $(this).offset().top;
			if ( _thisPos < _effectPos ) {
				$.when(
					$(this).addClass('is-show')
				).done(function() {
					$(this).delay(500).queue(function(){
						$(this).addClass('is-done')
					})
				});
			}
		});
	});
}

// スムーズスクロール ---------------------------------------/
const headerHeight = $('.l-header').height();
$('a[href^="#"]').click(function(){
	let speed = 500;
	let href= $(this).attr("href");
	let target = $(href == "#" || href == "" ? 'html' : href);
	let position = target.offset().top - headerHeight;
	let body = document.body;

	//沿革ページ、下からの移動で誤差が生じるため調整
	if (body.classList.contains('p-history')) {
		const historyHeaderHeight = 172; //header高さ * 2
		const historyPosition = target.offset().top - historyHeaderHeight;
		$("html, body").animate({scrollTop:historyPosition}, speed, "swing");
	}
	//他ページはheader分だけ
	else {
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	}
});
// ---------------------------------------/

//沿革ページ アンカーナビ(stickyしたら背景白塗りにする)
window.addEventListener('DOMContentLoaded', (event) => {
  window.addEventListener('scroll', function() {
    const isPC = window.matchMedia('(min-width: 1023px)').matches; // spとpcのブレークポイントを判定
    const header = isPC ? document.querySelector('.l-header.-pc') : document.querySelector('.l-header.-sp'); // 表示している.l-header要素を取得
    const nav = document.querySelector('.c-anchor__nav');
    if (nav) {
      const headerRect = header.getBoundingClientRect();
      const navRect = nav.getBoundingClientRect();
      if (navRect.top <= headerRect.bottom) {
        nav.classList.add('is-sticky');
      } else {
        nav.classList.remove('is-sticky');
      }
    }
  });
});

